import { armorAPI } from '~/services/api';
import { JSONCustomsDeclarationPayload } from '~/types/CustomsDeclaration';
import { JSONBatchEntriesCustomsItems, JSONCustomsItemPayload } from '~/types/CustomsItem';

function createCustomsItem(batchEntryIds: number[], customsItems: JSONCustomsItemPayload[]) {
  return armorAPI.request({
    url: '/batch_entry/customs_items',
    method: 'POST',
    data: {
      batch_entries: batchEntryIds,
      customs_items: customsItems,
    },
  });
}

function updateCustomsItem(batchEntryIds: number[], customsItem: JSONCustomsItemPayload) {
  return armorAPI.request({
    url: '/batch_entry/customs_items',
    method: 'PUT',
    data: {
      batch_entries: batchEntryIds,
      customs_items: [customsItem],
    },
  });
}

function deleteCustomsItems(batchEntryIds: number[], customsItems: JSONCustomsItemPayload[]) {
  return armorAPI.request({
    url: '/batch_entry/customs_items/',
    method: 'DELETE',
    data: {
      batch_entries: batchEntryIds,
      customs_items: customsItems,
    },
  });
}

function getCustomsItems(batchEntryIds: number[]) {
  return armorAPI.request<JSONBatchEntriesCustomsItems>({
    url: '/batch_entry/customs_items',
    params: { batch_entry_ids: batchEntryIds },
    method: 'GET',
  });
}

function updateCustomsDeclaration(
  batchEntryIds: number[],
  customsDeclaration: JSONCustomsDeclarationPayload,
) {
  return armorAPI.request({
    url: '/batch_entry/customs_declaration',
    method: 'PUT',
    data: {
      batch_entries: batchEntryIds,
      customs_declaration: customsDeclaration,
    },
  });
}

export {
  getCustomsItems,
  createCustomsItem,
  updateCustomsItem,
  deleteCustomsItems,
  updateCustomsDeclaration,
};
